import { cn } from "@/lib/utils";
import { ChevronUpRegular, FluentIcon } from "@fluentui/react-icons";
import { useState } from "react";
import { NavLink } from "react-router-dom";

interface SidebarGroupProps {
  label: string;
  children: {
    label: string;
    href: string;
  }[];
  Icon: FluentIcon;
}

function SidebarGroup({ label, children, Icon }: SidebarGroupProps) {
  const [open, setOpen] = useState(true);
  return (
    <div>
      <div
        className="flex h-[38px] cursor-pointer items-center gap-3 p-2"
        onClick={() => setOpen((open) => !open)}
      >
        <Icon className="text-cyan-600" fontSize={20} />
        <div className="grow text-sm font-bold leading-tight text-cyan-600">
          {label}
        </div>
        <ChevronUpRegular
          className={cn(
            "text-cyan-600 transition-transform",
            !open && "rotate-180",
          )}
        />
      </div>
      <div
        style={{
          height: open ? children.length * 38 : 0,
        }}
        className="flex flex-col overflow-hidden transition-all duration-300"
      >
        {children.map((item) => {
          return (
            <NavLink key={item.label} to={item.href}>
              {({ isActive }) => (
                <div
                  className={cn(
                    "flex h-[38px] cursor-pointer items-center gap-3 p-2 pl-10",
                    isActive && "rounded-[6px] bg-cyan-600",
                  )}
                >
                  <div
                    className={cn(
                      "font-bold",
                      isActive ? "text-white" : "text-cyan-600",
                    )}
                  >
                    {item.label}
                  </div>
                </div>
              )}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}

export default SidebarGroup;
